import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import { createFileRoute, useNavigate, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { useGraphQL } from "@/hooks/use-graphql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { ScheduleList } from "@/components/schedule/list/schedule-list";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";

import type { JSX } from "react";

const SchedulesPageQuery = graphql(/* GraphQL */ `
  query SchedulesPageQuery {
    ...SchedulesListQueryFragment
  }
`);

const schedulesSearchSchema = z.object({
  from: z.string().optional(),
});

const SchedulesPage = (): JSX.Element => {
  const queryResult = useGraphQL(SchedulesPageQuery);
  const { data } = queryResult;
  const navigate = useNavigate();
  const router = useRouter();
  const { from } = Route.useSearch();

  const handleBack = (): void => {
    if (from) {
      void navigate({ to: from });
    } else {
      router.history.back();
    }
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={handleBack} />
        <HeaderTitle title="Agendas" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <ScheduleList data={data} /> : <FullPageSpinner />}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/schedule-options/schedules/")({
  validateSearch: schedulesSearchSchema,
  component: SchedulesPage,
  pendingComponent: () => <PendingComponent title="Agendas" />,
});
